import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Default Tooltip", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " The default tootip with no location or class will display on hover to the right of the target. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("code", null, [
  /*#__PURE__*/_createTextVNode(" <v-tooltip text=\"This is the default tooltip. It shows to the right of the button when you hover it.\">"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("   <template v-slot:activator=\"{ props }\">"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("     <v-btn v-bind=\"props\">Default Tooltip (right)</v-btn>"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("   </template>"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" </v-tooltip> ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Defined Location", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Add a location and class to the tooltip element to move where the tooltip is shown.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("code", null, "<v-tooltip location=\"top\" class=\"top\" />", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("code", null, "<v-tooltip location=\"bottom\" class=\"bottom\" />", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("code", null, "<v-tooltip location=\"left\" class=\"left\" />", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "style-guide--tooltips" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _createVNode(_component_v_tooltip, { text: "This is the default tooltip. It shows to the right of the button when you hover it." }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                default: _withCtx(() => [
                  _createTextVNode("Default Tooltip (right)")
                ]),
                _: 2
              }, 1040)
            ]),
            _: 1
          }),
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", null, [
            _createVNode(_component_v_tooltip, {
              text: "This tooltip shows above the button when you hover it.",
              location: "top",
              class: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                  default: _withCtx(() => [
                    _createTextVNode("Tooltip Top")
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_tooltip, {
              text: "This tooltip shows below the button when you hover it.",
              location: "bottom",
              class: "bottom"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                  default: _withCtx(() => [
                    _createTextVNode("Tooltip Bottom")
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_v_tooltip, {
              text: "This tooltip shows to the left of the button when you hover it.",
              location: "left",
              class: "left"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _normalizeProps(_guardReactiveProps(props)), {
                  default: _withCtx(() => [
                    _createTextVNode("Tooltip Left")
                  ]),
                  _: 2
                }, 1040)
              ]),
              _: 1
            }),
            _hoisted_8
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}